import {
    CONSUMER_ORDER_RECEIVE,
    CONSUMER_ORDER_ERROR,
    CONSUMER_ORDER_CHANGE_MODE,
    CONSUMER_ORDER_CHANGE_CURRENTPAGE,
    CONSUMER_ORDER_SET_ORDER
} from '../ConstantsBrafab/constants';

import {
    ViewMode
} from '../constants';
import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    list: [],
    order: {},
    totalCount: 0,
    errors: {},
};

export const consumerOrder = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CONSUMER_ORDER_RECEIVE:
        case CONSUMER_ORDER_CHANGE_MODE:
        case CONSUMER_ORDER_CHANGE_CURRENTPAGE:
        case CONSUMER_ORDER_SET_ORDER:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case CONSUMER_ORDER_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
